import { TOOLTIP_DISPLAY_NAME } from "./core";
import createDisplayName from "../../../fabrics/createDisplayName";

export const createDisplayNameForTooltipElement =
    createDisplayName(TOOLTIP_DISPLAY_NAME);
